import { render } from "./DateNavigator.vue?vue&type=template&id=2028327e&scoped=true"
import script from "./DateNavigator.vue?vue&type=script&lang=js"
export * from "./DateNavigator.vue?vue&type=script&lang=js"

import "./DateNavigator.vue?vue&type=style&index=0&id=2028327e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2028327e"]])

export default __exports__